import React, { useCallback, useRef, useState } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import SiteSearch from "./SiteSearch";
import { useDismiss } from "./useDismiss";

/** Лупа в шапке на компьютере: открывает поиск по сайту. */
function HeaderSearch() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const close = useCallback(() => setOpen(false), []);
  useDismiss(ref, open, close);

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        className="header-icon-btn"
        aria-label="Поиск по сайту"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <MagnifyingGlassIcon className="h-7 w-7" aria-hidden="true" />
      </button>
      {open ? (
        <div className="header-popover header-popover-right w-[26rem]">
          <SiteSearch autoFocus onNavigate={close} inputId="header-search" />
        </div>
      ) : null}
    </div>
  );
}

export default HeaderSearch;
